import React from 'react';
import { useTranslation } from 'react-i18next';
import { Play, Sparkles } from 'lucide-react';
import { getCategoryStyle, fmtDuration, fmtViews } from './QoreTalksShell';

const FeaturedEpisode = ({ talk, onPlay }) => {
  const { t } = useTranslation();
  if (!talk) return null;
  const style = getCategoryStyle(talk.category);
  const hasThumb = talk.thumbnailUrl && !talk.thumbnailUrl.includes('/api/placeholder');

  return (
    <section className="qt-featured qt-motion-item" aria-label={t('qoreTalks.featuredLabel')}>
      <div
        className="qt-featured__inner"
        style={style}
        onClick={() => onPlay(talk)}
        onKeyDown={(e) => e.key === 'Enter' && onPlay(talk)}
        role="button"
        tabIndex={0}
      >
        <div className="qt-featured__media">
          {hasThumb ? (
            <img src={talk.thumbnailUrl} alt="" loading="lazy" />
          ) : (
            <div className="qt-featured__placeholder">
              <Play size={56} strokeWidth={1.25} />
            </div>
          )}
        </div>
        <div className="qt-featured__content">
          <span className="qt-featured__badge">
            <Sparkles size={14} /> {t('qoreTalks.featuredLabel')}
          </span>
          <span className="qt-card__category">{talk.category}</span>
          <h2 className="qt-featured__title">{talk.title}</h2>
          <p className="qt-featured__desc">
            {(talk.description || '').slice(0, 160)}
            {(talk.description || '').length > 160 ? '…' : ''}
          </p>
          <div className="qt-featured__meta">
            <span className="qt-card__host-avatar">{(talk.host?.name || 'H').charAt(0)}</span>
            <span>{talk.host?.name}</span>
            <span>· {fmtDuration(talk.duration)}</span>
            <span>· {fmtViews(talk.analytics?.views)} {t('qoreTalks.views')}</span>
          </div>
          <span className="qt-btn qt-btn--primary qt-featured__cta">
            <Play size={18} fill="currentColor" /> {t('qoreTalks.watchNow')}
          </span>
        </div>
      </div>
    </section>
  );
};

export default FeaturedEpisode;